import React from "react";

import styled from "styled-components";

const ReviewVaspButton = styled.div<{ hasPadding: boolean }>`
  cursor: pointer;
  height: 43px;

  display: flex;
  justify-content: center;
  align-items: center;

  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;

  text-align: center;
  text-transform: uppercase;

  background: #1f1f1f;
  border-radius: 4px;
  color: #ffffff;

  ${(params) => params.hasPadding && `padding: 8px;`}
`;

const TextStyle = styled.span`
  ont-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;

  text-align: center;
  text-transform: uppercase;
`;

export default function ReviewVaspLink({
  hasPadding = true,
  clickable = false,
}: {
  hasPadding: boolean;
  clickable: boolean;
}) {
  if (!clickable) {
    return <TextStyle>NOT REVIEWED</TextStyle>;
  }
  return <ReviewVaspButton hasPadding={hasPadding}>REVIEW VASP</ReviewVaspButton>;
}
